// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"efc53470","453":"5853fb54","744":"87cc68ef","801":"12d50df6"}[chunkId] + ".chunk.js";
};